import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/door-access/readers-and-intercoms/g2-reader.png";
import type { Product } from "../../types";
import { doorAccessReadersIntercom } from "../product-list-groups/doorAccessReadersIntercom";
import {
  cameraReader,
  directory,
  hand,
  mobileAppAccess,
  mobileTap,
  nfcCard,
  outdoorReady,
  pinAccess,
  readerPowerMethod,
  touchPassSupport,
  twoWayIntercom,
} from "../properties";

export const g2Reader: Product = {
  id: "g2Reader",
  productTitle: "G2 Reader",
  description: "g2Reader.description",
  techspecsPath: [SiteId.TechSpecs, "/unifi/door-access/ua-g2"],
  storePathParts: {
    category: "door-access-readers",
    collectionSlug: "access-reader-g2",
    productSlug: "ua-g2",
  },
  productListGroup: doorAccessReadersIntercom,
  descriptionMaxWidth: 210,
  image: { src: image, width: 200, height: 160 },
  propertyValues: [
    {
      propertyId: "dimensions",
      value: { type: "string", value: '93 x 40 x 36.5 mm\n(3.7 x 1.6 x 1.4")' },
    },
    {
      propertyId: cameraReader.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: twoWayIntercom.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: directory.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: directory.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: touchPassSupport.id,
      value: {
        type: "boolean",
        value: false,
      },
    },
    {
      propertyId: pinAccess.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: nfcCard.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: mobileAppAccess.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: mobileTap.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: hand.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: outdoorReady.id,
      value: {
        type: "translation",
        value: "g2Reader.outdoorReady",
      },
    },
    {
      propertyId: readerPowerMethod.id,
      value: {
        type: "translation",
        value: "readerPowerMethod.poeViaUniFiControlHub",
      },
    },
  ],
};
